import { render, staticRenderFns } from "./OwnedBranchTree.vue?vue&type=template&id=6a8656a4&"
import script from "./OwnedBranchTree.vue?vue&type=script&lang=js&"
export * from "./OwnedBranchTree.vue?vue&type=script&lang=js&"
import style0 from "./OwnedBranchTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8656a4')) {
      api.createRecord('6a8656a4', component.options)
    } else {
      api.reload('6a8656a4', component.options)
    }
    module.hot.accept("./OwnedBranchTree.vue?vue&type=template&id=6a8656a4&", function () {
      api.rerender('6a8656a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/OwnedBranchTree.vue"
export default component.exports